<template>
  <div class="history-window-component">
    <template v-if="!showAddressWindow">
      <s-tabs>
        <s-tab name="Карточка клиента" :selected="currentTab === 'client'">
          <v-loader v-show="isLoadingClient" absolute fixed />

          <div class="button-group d-flex justify-between mb-7">
            <v-row dense class="justify-space-between">
              <v-col sm="5">
                <v-btn
                  width="100%"
                  class="button button-back"
                  color="#F1F3F6"
                  @click="goBack"
                >
                  <font-awesome-icon icon="chevron-left" />
                  Вернуться назад
                </v-btn>
              </v-col>
            </v-row>
          </div>

          <div v-if="!isLoadingClient" class="mb-5">
            <h1 v-if="clientInfo.name" class="step-title font-weight-bold mb-0">
              {{ clientInfo.name }}
            </h1>
            <h3 v-if="clientInfo.phone" class="client-phone-block">
              {{ clientInfo.formattedPhone || clientInfo.phone }}
            </h3>
            <h2 v-else class="client-phone-block">
              Клиент без регистрации
            </h2>
          </div>

          <client-summary-info :client="clientInfo" />

          <v-row>
            <v-col>
              <div class="bonus-birthday-summary-section d-flex align-center">
                <div class="bonus-summary-items d-flex">
                  <div class="bonus-summary d-flex a-center">
                    <img src="/img/icons/setcoins-icon.svg" class="bonus-icon" />
                    <div class="summary-info d-flex flex-column">
                      <span class="summary-title">
                        На счету
                        <span class="summary-source">({{ bonusSourceLabel }})</span>
                        <font-awesome-icon icon="arrow-up" color="green" />
                      </span>
                      <span class="summary-balance font-weight-medium">{{ clientInfo.foxcoinBalance }}</span>
                    </div>
                  </div>
                  <div class="bonus-summary d-flex a-center">
                    <div class="summary-info d-flex flex-column">
                      <span class="summary-title">
                        Потрачено
                        <font-awesome-icon icon="arrow-down" color="red" />
                      </span>
                      <span class="summary-balance font-weight-medium">{{ clientInfo.foxcoinSpen }}</span>
                    </div>
                  </div>
                </div>
                <div class="client-birthday d-flex align-center">
                  <icon-cake />
                  <div class="d-flex flex-column">
                    <span>День рождения:</span>
                    <span class="client-birthday__value">{{ clientInfo.birthdayString || 'не указан' }}</span>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col sm="5">
              <template v-if="lastOrder">
                <span class="label">Последний заказ на сумму:</span>
                <div class="last-client-order d-flex align-center">
                  <span class="summ font-weight-medium">{{ getLastOrderPrice | amountWithCurrency0 }}</span>
                  <icon-info />
                  <span class="date">{{ getLastOrderDate }}</span>
                </div>
              </template>
              <span class="label">Примечание оператора:</span>
              <v-textarea
                v-model="operatorComment"
                placeholder="Введите сообщение"
                solo
                depressed
                hide-details="auto"
                no-resize
                class="operator-comment-textarea"
                @input="operatorCommentIsChange = true"
              />
              <div class="d-flex justify-end">
                <v-btn
                  v-show="operatorCommentIsChange"
                  :loading="updatingOperatorComment"
                  class="mb-5 pull-left"
                  depressed
                  color="success"
                  @click="updateOperatorComment"
                >
                  Сохранить
                </v-btn>
              </div>
            </v-col>
            <v-col sm="7">
              <div class="negative-promocodes-block">
                <div class="d-flex a-center j-between">
                  <span class="label label-negative-promocode font-weight-medium">Промокод за негатив:</span>
                <!--                <v-btn
                  :disabled="!currentPromocode"
                  class="button-success"
                  dark
                  @click="showPromocodeDialog = true"
                >
                  Добавить промокод клиенту
                </v-btn>-->
                </div>
                <div class="promocode-description d-flex flex-column">
                  <template v-if="false && currentPromocode">
                    <span class="promocode-title font-weight-medium">&nbsp;{{ getPromocodeName }}</span>
                    <span class="description">{{ getPromocodeDescription }}</span>
                  </template>
                  <template v-else>
                    <span v-if="userCanAddNegativePromoCode" class="promocode-empty-label">Выберите промокод для начисления клиенту:</span>
                    <span v-else class="promocode-empty-label promocode-empty-label__disabled">Вы не можете начислять бонусы за негатив</span>
                  </template>
                </div>
                <div class="promocodes">
                  <v-btn-toggle v-model="currentPromocode" dense group>
                    <v-row>
                      <v-col
                        v-for="(promocode, i) in negativePromoCodes"
                        :key="i"
                        :sm="6"
                        :md="6"
                        :xl="4"
                      >
                        <!--                    @click="changePromocode(promocode.id)"-->
                        <!--                    :value="category.id"-->
                        <v-btn
                          class="button-promocode"
                          block
                          light
                          depressed
                          :value="promocode.id"
                          :disabled="isClientAnonymous || !userCanAddNegativePromoCode"
                          @click="showPromocodeDialog = true"
                        >
                          {{ promocode.name }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-btn-toggle>
                </div>
              </div>
            </v-col>
          </v-row>

          <client-addresses-list :client-id="basket.clientId" />
        </s-tab>
        <s-tab name="История заказов" :selected="currentTab === 'history'">
          <div class="button-group d-flex justify-between mb-7">
            <v-row dense class="justify-space-between">
              <v-col sm="5">
                <v-btn
                  class="button button-back"
                  width="100%"
                  color="#F1F3F6"
                  @click="goBack"
                >
                  <font-awesome-icon icon="chevron-left" />
                  Вернуться назад
                </v-btn>
              </v-col>
            </v-row>
          </div>
          <v-loader v-if="showOrdersGlobalLoading" />
          <template v-if="!showOrdersGlobalLoading">
            <order-card-history
              v-for="(order, i) in orders"
              :key="i"
              :order="order"
              hide-client-phone
              class="client-order-card"
              @addToCart="addToCart"
            />
            <div class="d-flex justify-center">
              <v-btn
                v-if="showOrdersMoreButton"
                :loading="isOrdersLoading"
                class="button-primary"
                @click="getClientOrders"
              >
                Загрузить еще
              </v-btn>
            </div>
          </template>
        </s-tab>
      </s-tabs>

      <v-dialog
        v-model="showPromocodeDialog"
        width="1068"
        class="promocode-dialog"
      >
        <v-card>
          <v-card-title>
            <div class="d-block text-center fullwidth">
              <span class="display-3 font-weight-regular">Укажите причину для начисления "{{ getPromocodeName }}"</span>
            </div>
          </v-card-title>
          <div class="d-flex justify-center">
            <v-btn-toggle
              v-model="promocodeReason"
              dense
              group
              class="d-flex fullwidth dialog-toggle-section"
            >
              <v-btn
                class="button-primary-toggle"
                light
                depressed
                value="kitchen"
              >
                Опоздание кухни
              </v-btn>
              <v-btn
                class="button-primary-toggle"
                light
                depressed
                value="taste"
              >
                Не вкусно
              </v-btn>
              <v-btn
                class="button-primary-toggle"
                light
                depressed
                value="courier"
              >
                Проблема с курьером
              </v-btn>
            </v-btn-toggle>
          </div>
          <div class="d-flex justify-center">
            <v-textarea
              v-model="promocodeComment"
              placeholder="Укажите свою причину"
              solo
              depressed
              hide-details="auto"
              no-resize
              color="#000000"
              class="textarea-secondary pl-10 pr-10 pt-5 pb-5"
            />
          </div>
          <v-card-actions>
            <div class="d-flex justify-center fullwidth pb-5">
              <v-btn class="button-back mr-5" @click="showPromocodeDialog = false">
                <font-awesome-icon icon="chevron-left" />
                Вернуться назад
              </v-btn>
              <v-btn
                :loading="isPromocodeLoading"
                :disabled="!promocodeReason && !promocodeComment"
                class="button-success"
                @click="applyPromocode"
              >
                <font-awesome-icon icon="check" />
                Применить
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

    <address-window
      v-if="showAddressWindow"
      :address="currentEditAddress"
      @close="showAddressWindow = false"
      @onClose="getClientInfo"
    />
  </div>
</template>

<script>
  import moment from 'moment'
  import _ from 'lodash'
  import { mapState } from 'vuex'
  import OrderCard from './order-card/OrderCardHistory.vue'
  import VAddress from '../second-step/Address'
  import AddressWindow from './address-window/AddressWindow'
  import VLoader from '@/components/loader/Loader'
  import IconCake from './icons/IconCake'
  import IconCart from './icons/IconCart'
  import IconCheck from './icons/IconCheck'
  import IconClocks from './icons/IconClocks'
  import IconFriends from './icons/IconFriends'
  import IconMoney from './icons/IconMoney'
  import IconSad from './icons/IconSad'
  import IconSmile from './icons/IconSmile'
  import IconInfo from './icons/IconInfo'
  import IconFoxcoin from '../../../icons/IconFoxcoin'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'
  import STabs from '@/components/ui/tabs/STabs.vue'
  import STab from '@/components/ui/tabs/STab.vue'
  import OrderStatus from '@/models/enums/OrderStatus'
  import { formatIsoDateTimeAsDateTime } from '@/util/date-time-helper'
  import OrderCardHistory from '@/components/order-processing/order-components/history/order-card/OrderCardHistory.vue'
  import ClientAddressesList from '@/components/order-processing/order-components/history/ClientAddressesList.vue'
  import PromoCodeDataService from '@/services/api/PromoCodeDataService'
  import ClientSummaryInfo from '@/components/order-processing/order-components/history/ClientSummaryInfo.vue'
  import CRMPermission from '@/models/enums/permissions/CRMPermission'

  export default {
    name: 'HistoryWindow',
    components: {
      ClientSummaryInfo,
      ClientAddressesList,
      OrderCardHistory,
      STab,
      STabs,
      OrderCard,
      VAddress,
      AddressWindow,
      VLoader,
      IconCake,
      IconCart,
      IconCheck,
      IconClocks,
      IconFriends,
      IconMoney,
      IconSad,
      IconSmile,
      IconInfo,
      IconFoxcoin,
    },
    mixins: [mixinSnackbarMessage],
    data () {
      return {
        isLoadingClient: false,
        isPromocodeLoading: false,
        showOrdersGlobalLoading: true,
        isOrdersLoading: false,
        showOrdersMoreButton: true,
        showPromocodeDialog: false,
        showAddressWindow: false,
        currentTab: 'client',
        currentPromocode: null,
        promocodeReason: null,
        promocodeComment: '',
        updatingOperatorComment: false,
        operatorComment: '',
        operatorCommentIsChange: false,
        negativePromoCodes: [],
        orders: [],
        clientInfo: {
          clientAddresses: [],
        },
        tabs: [
          { key: 'Карточка клиента', value: 'client' },
          { key: 'История заказов', value: 'history' },
        ],
        currentEditAddress: null,
        addresses: [],
        ordersOffset: 0,
      }
    },
    watch: {
      showPromocodeDialog () {
        if (this.showPromocodeDialog) {
          this.promocodeReason = null
          this.promocodeComment = ''
        } else {
          this.currentPromocode = null
        }
      },
    },
    computed: {
      /** Источник бонусов клиента: локальная история FACT или внешняя система Юпитер */
      bonusSourceLabel () {
        return this.clientInfo.bonusesManagedByFact ? 'ФАКТ' : 'Юпитер'
      },
      ...mapState({
        basket: state => state.baskets.basket,
      }),
      isClientAnonymous () {
        return !this.basket.client?.phone
      },
      lastOrder () {
        return _.find(this.orders, (order) => order.orderStatus !== OrderStatus.Canceled)
      },
      getLastOrderPrice () {
        return this.lastOrder ? this.lastOrder.totalPrice : 0
      },
      getLastOrderDate () {
        return this.lastOrder ? formatIsoDateTimeAsDateTime(this.lastOrder.createdAt) : ''
      },
      getPromocodeName () {
        try {
          return this.negativePromoCodes.find(promocode => promocode.id === this.currentPromocode).name
        } catch {
          return ''
        }
      },
      getPromocodeDescription () {
        try {
          return this.negativePromoCodes.find(promocode => promocode.id === this.currentPromocode).description
        } catch {
          return ''
        }
      },
      currentAddressId () {
        return this.basket.clientAddress ? this.basket.clientAddress.id : 0
      },
      userCanAddNegativePromoCode () {
        return this.userCan(CRMPermission.AddNegativePromoCodesToClients)
      },
    },
    mounted () {
      this.getClientInfo()
      this.loadPromocodes()
      // this.getClientAddresses()
      this.getClientOrders()
      // this.currentPromocode = this.basket.promoCode.promoCode.id
      // this.currentAddressId = this.basket.clientAddress.id
    },
    created () {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    beforeDestroy () {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    methods: {
      goBack () {
        this.$store.commit('fastOrder/setCurrentOtherWindow', undefined)
        this.$store.commit('newOrder/setCurrentOtherWindow', undefined)
      },
      updateOperatorComment () {
        const id = this.basket.client.id
        if (this.operatorComment === '') {
          this.operatorComment = null
        }
        const data = {
          comment: this.operatorComment,
        }
        this.updatingOperatorComment = true
        this.$store.dispatch('clients/editClients', { id, data }).then(res => {
          if (res.status === 200) {
            this.operatorCommentIsChange = false
            this.showSuccessMessage('Комментарий обновлен')
          } else {
            this.showErrorMessage(res.response.data.message)
          }
        })
          .finally(() => {
            this.updatingOperatorComment = false
          })
      },
      editAddress (value) {
        this.currentEditAddress = value
        this.showAddressWindow = true
      },
      addToCart (id) {
        const payload = {
          menuItemId: id,
        }
        this.$store
          .dispatch('baskets/addBasketItem', {
            data: payload,
            id: this.basket.id,
          })
          .then((res) => {
            if (res.status === 200) {
              this.$store.commit('baskets/setBasket', res.data.data)
            } else {
              this.showErrorMessage(res.response.data.message)
            }
          })
      },
      getClientInfo () {
        this.isLoadingClient = true
        const id = this.basket.clientId
        if (!id) return
        this.$store.dispatch('clients/fetchClientInfo', id)
          .then(res => {
            this.clientInfo = res.data.data
            this.operatorComment = this.clientInfo.comment
          })
          .finally(() => {
            this.isLoadingClient = false
          })
      },
      applyPromocode () {
        this.isPromocodeLoading = true
        const data = {
          promoCodeId: this.currentPromocode,
          comment: this.promocodeComment,
          promocodeReason: this.promocodeReason || 'custom',
        }

        const id = this.basket.client.id
        const basketId = this.basket.id

        this.$store.dispatch('clients/addPromocode', { data, id }).then(res => {
          if (res.status === 200) {
            this.showSuccessMessage('Промокод добавлен')
            this.$store.dispatch('baskets/fetchSingleBasket', basketId)
            this.getClientInfo()
            this.showPromocodeDialog = false
            this.currentPromocode = null
          } else {
            this.showErrorMessage(res.response.data.message)
          }
        }).finally(() => {
          this.isPromocodeLoading = false
        })
      },
      async loadPromocodes () {
        try {
          this.negativePromoCodes = await PromoCodeDataService.getNegativeItems()
        } catch (err) {
          this.showErrorFromResponse(err)
        }
      },
      async getClientAddresses () {
        console.log('on close')
        const clientId = this.basket.client.id
        if (!clientId) return

        const payload = {
          clientId,
          limit: 100,
        }

        try {
          const res = await this.$store.dispatch('clients/fetchClientsAddressList', payload)
          this.addresses = []
          setTimeout(() => {
            this.addresses = res.data.items
          }, 1000)
        } catch (err) {
          console.warn('Error', err)
        }
      },
      async getClientOrders () {
        if (!this.basket) {
          return null
        }
        this.isOrdersLoading = true
        const clientId = this.basket.client.id
        if (!clientId) return

        const payload = {
          clientId,
          limit: 20,
          offset: this.ordersOffset,
          sortField: 'id',
          sortMethod: 'desc',
          orderField: 'date',
        }

        try {
          const res = await this.$store.dispatch('orders/fetchOrdersList', payload)
          this.orders.push(...res.data.items)
          this.ordersOffset += 20
          if (res.data.meta.total <= this.orders.length) {
            this.showOrdersMoreButton = false
          }
        } catch (err) {
          console.warn('Error', err)
        } finally {
          this.isOrdersLoading = false
          this.showOrdersGlobalLoading = false
        }
      },
    },
  }
</script>

<style lang="less" scoped>
  ::v-deep {
    .dialog-toggle-section {
      padding: 0 40px !important;
      width: 100% !important;
      .v-btn {
        flex: 1;
      }
    }
  }
  .history-window-component {
    font-size: 12px;

    .media-xl({
      font-size: 14px;
    });

    .window-title {
      font-size: 2.42em;
      line-height: 1;
    }

    .label {
      display: block;
      margin-bottom: 10px;

      &.label-negative-promocode {
        margin-right: 10px;
        font-size: 1.6em;
        line-height: 1.1;
      }
    }

    .client-order-card {
      margin-bottom: 16px;
    }

    .client-summary {
      border-radius: 5px;
      background: #fff3d6;
      padding: 10px 24px;
      margin-bottom: 35px;

      .summary-item {
        margin-right: 20px;
        .media-xl-max({
          margin-right: 10px;
        })

        &:last-child {
          margin-right: 0;
        }

        .icon {
          margin-right: 12px;
          .media-xl-max({
            margin-right: 7px;
           svg {
             transform: scale(0.85);
           }
          });
        }

        .summary-title {
          font-weight: 300;
          font-size: 1.12em;
          line-height: 1;

          .media-xl-max({
            font-size: 1em;
            margin-bottom: 2px;
          });
        }

        .summary-value {
          font-weight: bold;
          font-size: 1.12em;
          line-height: 1;
          white-space: nowrap;
        }
      }
    }

    .bonus-birthday-summary-section {
      margin-bottom: 40px;

      .bonus-summary-items {
        margin-right: 15px;

        .bonus-summary {
          padding-right: 20px;
          &:first-child {
            border-right: 1px solid #d4ddeb;
            margin-right: 15px;
          }
          svg {
            margin-right: 15px;
          }

          .summary-title {
            font-size: 1.1em;
            line-height: 1.1;
          }

          .summary-source {
            color: #999999;
            font-size: 0.85em;
            margin-right: 4px;
          }

          .bonus-icon {
            width: 41px;
            margin-right: 15px;
          }

          .summary-balance {
            font-size: 1.78em;
            line-height: 1;
          }
        }
      }

      .client-birthday {
        font-size: 1.1em;
        line-height: 1.3;
        svg {
          margin-right: 1.2em;
        }

        &__value {
          font-size: 1.1em;
          font-weight: bold;
          margin-bottom: -3px;
        }
      }
    }

    .last-client-order {
      background-color: #f1f3f6;
      border-radius: 10px;
      padding: 25px 30px;
      margin-bottom: 16px;

      span {
        font-size: 1.42em;
      }

      .summ {
        font-size: 24px;
      }

      svg {
        margin-left: 1.7em;
        margin-right: 10px;
      }
    }

    .operator-comment-textarea {
      margin-bottom: 20px;

      ::v-deep {
        .v-input__slot {
          box-shadow: none !important;
          background-color: #f1f3f6;
          border-radius: 10px;
        }
      }
    }

    .negative-promocodes-block {
      padding-top: 55px;
    }

    .promocode-description {
      margin-top: 15px;
      margin-bottom: 3px;
      //min-height: 60px;
      position: relative;

      span {
        font-size: 1.42em;
      }

      .promocode-empty-label {
        font-size: 1.14em;
        margin-top: 35px;
        position: absolute;
        bottom: -5px;

        &__disabled {
          color: #999999;
          //font-weight: 300;
        }
      }
    }

    .promocodes {
      ::v-deep {
        .v-item-group {
          width: 100%;
        }
        .button-promocode.v-btn {
          border-radius: 10px;
          background-color: #F1F3F6;
          font-weight: 500;
          height: 3.8em;
          font-size: 12px;
          .media-xl({
            height: 3.8em;
            font-size: 1.5em;
          });

          &.v-btn--active {
            color: #ffffff;
            background-color: @color-primary;
          }
        }
      }

      .row {
        .col {
          padding-right: 5px;
          padding-left: 5px;
          &:nth-child(odd) {
            //padding-right: 5px;
            padding-bottom: 5px;
          }
          &:nth-child(even) {
            //padding-left: 5px;
            padding-bottom: 5px;
          }
        }
      }
    }

    .button-group {
      margin-bottom: 21px;

      .button {
        font-size: 15px;
        box-shadow: 0 3px 6px #00000029 !important;

        svg {
          margin-right: 8px;
        }
      }

      .button-back {
        svg {
          .fill-svg(#0033ff);
        }
      }
    }
  }
</style>
